import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useTriggerScraper, useTriggerScheduledSearches } from '../../hooks/useAdmin';

export default function AdminManualTriggers() {
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const triggerScraper = useTriggerScraper();
    const triggerSS = useTriggerScheduledSearches();

    const handleTrigger = async (mutation, label) => {
        try {
            await mutation.mutateAsync();
            setToast({ open: true, message: `${label} pokrenut!`, severity: 'success' });
        } catch {
            setToast({ open: true, message: `Greška pri pokretanju: ${label}`, severity: 'error' });
        }
    };

    return (
        <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, py: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#2c3e50', mb: 2 }}>
                Ručno pokretanje
            </Typography>
            <Paper sx={{ p: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Button
                    variant="contained"
                    startIcon={<PlayArrowIcon />}
                    onClick={() => handleTrigger(triggerScraper, 'Scraper')}
                    disabled={triggerScraper.isPending}
                    sx={{ backgroundColor: '#2980b9', textTransform: 'none' }}
                >
                    Pokreni scraper
                </Button>
                <Button
                    variant="contained"
                    startIcon={<PlayArrowIcon />}
                    onClick={() => handleTrigger(triggerSS, 'Automatizirane pretrage')}
                    disabled={triggerSS.isPending}
                    sx={{ backgroundColor: '#e67e22', textTransform: 'none' }}
                >
                    Pokreni pretrage
                </Button>
            </Paper>
            <Snackbar
                open={toast.open}
                autoHideDuration={3000}
                onClose={() => setToast(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={toast.severity} variant="filled" onClose={() => setToast(prev => ({ ...prev, open: false }))}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
